import { render, staticRenderFns } from "./studentResponseDetails.vue?vue&type=template&id=3a2ab675&scoped=true"
import script from "./studentResponseDetails.vue?vue&type=script&lang=js"
export * from "./studentResponseDetails.vue?vue&type=script&lang=js"
import style0 from "./studentResponseDetails.vue?vue&type=style&index=0&id=3a2ab675&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2ab675",
  null
  
)

export default component.exports